import React from 'react';

function FirstPage() {
  return (
    <h1>Page 1</h1>
  );
};

export default FirstPage;
